import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import List from "./pages/List";
import ViewVouchers from "./pages/ViewVouchers";

export const customPages = [
	{ moduleId: "3a16a253-06c0-4a95-9581-d71188249a4d", path: "list", content: <List /> },
	{ moduleId: "3a16a253-06c0-4a95-9581-d71188249a4d", path: "view-vouchers/:id", content: <ViewVouchers /> },
] as CustomPage[];
